import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import ShiftTradeLogo from '../svg/ShiftTradeLogo';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      width: '10rem',
      height: '3.5rem',
      padding: theme.spacing(1),
    },
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <Box className={classes.header}>
      <ShiftTradeLogo />
    </Box>
  );
};

export default Header;
